import React from 'react';
import { SUPPORT_HUB_LINK } from '@Containers/CasNumber/constants';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import { LinkElement } from '@els/els-react--link-element';

function CasNumberErrorToastMessageContent() {
  return (
    <div className="cas-number-toast-message__content">
      The service is currently unavailable, please try again later. To learn more{' '}
      <LinkElement
        data-e2e="cas-number-learn-more-link"
        href={SUPPORT_HUB_LINK}
        isExternal
        noExternalIcon
        inline
        className="e2e-cas-api-error-help">
        click here
      </LinkElement>
      .
    </div>
  );
}

export const showCasNumberErrorToastMessage = () =>
  newToastMessage({
    iconId: '#icon-cas-number',
    title: 'We cannot retrieve the CAS Registry Number',
    content: <CasNumberErrorToastMessageContent />,
    color: 'warn',
  });

export default CasNumberErrorToastMessageContent;
